<template>
  <div class="container" id="recommended">
    <div class="container-top border-bottom">
        <span>每周<span class="groom">推荐</span><span class="font">平台精选货品，您值得拥有</span></span>
    </div>
    <router-link class="detail border-bottom" tag="div" :to="'/detail/' + item.id" v-for="item in list" :key="item.id">
      <img :src="item.imgUrl ? url + item.imgUrl : defaultimg">
      <h5>{{item.title}}</h5>
      <span class="dollars">¥<span class="price"> {{item.price}}</span></span>
    </router-link>
  </div>
</template>

<script>
import url from '@/common/common.js'
export default {
  name: 'HomeRecommended',
  props: {
    list: Array
  },
  data () {
    return {
      url,
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  }
}
</script>

<style scoped>
.container{ background: #fff;}
.container-top{ padding: 13px 8px;}
.container-top span{ font-size: 14px; font-family: '微软雅黑'; color: #fd5a0d; background-color: #fff; padding: 10px 2px; padding-right: 0; font-weight: bold; letter-spacing: 1px;}
.container-top .groom{ color: #333; padding-left: 0;}
.container-top .font{ padding: 10px; color: #7f7f7f; padding-right: 40px; font-weight: normal; font-size: 13px; letter-spacing: 0;}
.detail{ overflow: hidden;}
.detail img{ float: left; margin: 8px; border-radius: 5px; width: 80px; height: 80px;}
.detail h5{ font-weight: 500; padding: 10px 38px 3px 0; color: #333; word-break: break-all; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;}
.detail p{ font-size: 12px; padding-top: 3px; color: #656565;}
.detail a{ text-decoration: none;}
.dollars{ display: block; padding-top: 3px; color: #fd5a0f; font-size: 12px;}
.price{ font-size: 14px;}
.detail-last{ border-bottom: 0;}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/Recommended.vue